import { z } from 'zod';
/**
 * Transport modes for delivering a tab's picture to viewers.
 * MVP implements `screencast` (CDP Page.startScreencast relayed over WebSocket).
 * Future modes (e.g. `webrtc`) are added here; nodes advertise what they support in `hello`,
 * Browser profiles carry a default, and viewers pick one when joining.
 */
export const STREAM_MODES = ['screencast'];
export const StreamModeSchema = z.enum(STREAM_MODES);
export const ScreencastParamsSchema = z.object({
    /** JPEG quality 1-100 */
    quality: z.number().int().min(1).max(100).default(70),
    /** Downscale cap in device pixels; omit to send native size */
    maxWidth: z.number().int().min(160).max(4096).optional(),
    maxHeight: z.number().int().min(160).max(4096).optional(),
    everyNthFrame: z.number().int().min(1).max(10).default(1),
});
/** Per-mode parameter schema. Keys must match STREAM_MODES. */
export const StreamParamsSchema = z.discriminatedUnion('mode', [
    z.object({ mode: z.literal('screencast'), params: ScreencastParamsSchema.partial().default({}) }),
]);
//# sourceMappingURL=modes.js.map